import { z } from "zod";
import { messages } from "@/config/messages";

// Simplified schema for sub-user settings (Leads only)
export const editSubUserSettingSchema = z.object({
  id: z.string().optional(),
  agencyEmail: z.string().optional(),
  additionalEmail: z.array(
    z.object({
      email: z
        .string()
        .email({ message: messages.invalidEmail })
        .min(1, { message: messages.emailIsRequired }),
    })
  ),
  privyrUrl: z.string().optional(),
  privyrEnabled: z.boolean().optional(),
});

export type EditSubUserSettingSchema = z.infer<typeof editSubUserSettingSchema>;
